/* istanbul ignore file */
import { DeleteButton, DeleteButtonProps } from 'framework/ui/ui-builder';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { HTTP } from 'framework/api';
import { useEmployeeUrl, useEmployeeService, DELETE_EMPLOYEE } from 'domain/shared/employee';

const DeleteEmployeeButton = (props: Partial<DeleteButtonProps>) => {
  const { getListUrl } = useEmployeeUrl();
  const { deleteById } = useEmployeeService();
  const id = useEmployeeId();

  const handleDelete = () => deleteById(id!);

  return (
    <DeleteButton
      {...props}
      displayMessage="Do you really want to delete this employee?"
      deleteMethod={handleDelete}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Worker has been successfully deleted.',
        errorMessage: `Can't delete Worker.`,
        errorStatusesMessages: {
          [HTTP.BAD_REQUEST]: 'Workers with the Employee or Owner roles cannot be deleted.',
        },
      }}
      permissionToCheck={DELETE_EMPLOYEE}
    />
  );
};

export default DeleteEmployeeButton;
